import { Component } from "react"

export default class Pipe extends Component<any> {
    render() {
        const width = this.props.body.bounds.max.x - this.props.body.bounds.min.x;
        const height = this.props.body.bounds.max.y - this.props.body.bounds.min.y;
        const x = this.props.body.position.x - width / 2;
        const y = this.props.body.position.y - height / 2;
        const pipeClass = this.props.class;

        return (
            <div
                className={`pipe ${pipeClass}`}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,
                    width: width,
                    height: height
                }} />
        );
    }
}